function contactPopup() {
	let contactButton = document.getElementById('contactPopupButton')
	if (contactButton) {
		contactButton.onclick = function () {
			document.getElementById('contactPopup').classList.add('active');
		};
	}


	let closePopupButton = document.getElementById('closePopupButton')
	if (closePopupButton) {
		closePopupButton.onclick = function () {
			document.getElementById('contactPopup').classList.remove('active');
		};
	}
}

export {contactPopup};